enum links {
	dashboard = '/dashboard',
	news = '/news',
	services = '/services',
	contracts = '/contracts',
	contract = '/contracts?contract=',
	payment = '/payment/:id',
	tabContract = '&?tab=',
	requests = '/requests',
	questions = '/questions',
	profile = '/profile',
	makeRequest = '/request/make',
	newsDetails = '/details',
	checkOkta = '/implicit/callback',
	alertDetails = '/alert',
	footer = '/footer',
	cgu = '/cgu',
	preview = '/preview/drupal/content',
	formulaireChangementAppartement = '/change-property'
}

export default links
